export default "__VITE_ASSET__5EpxqVdF__"